import React from 'react';
import './App.css';
import { Route } from 'wouter';
import MerchantPage from './pages/MerchantPage';
import { UserContext } from './context/UserContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { UserType } from './types/user';
import ProfilePage from './pages/ProfilePage';
import TransactionPage from './pages/TransactionPage';

interface AppProps {
  authUser?: UserType | null;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC<AppProps> = ({ authUser }) => {
  if (process.env.NODE_ENV === 'development') {
    authUser = {
      id: 10,
      user_login: 'storeA',
      name: 'Store A',
      email: 'storea@test.com',
      phones: ['085608244331'],
      avatar_url: 'http://localhost:81/wp-content/uploads/2021/12/images.png',
      user_level: 'subscriber',
      roles: ['wcfm_vendor'],
      point: "1000",
      merchant_data: {
        store_name: 'Store A',
        merchant_mobile_banner:
          'http://localhost:81/wp-content/uploads/2022/01/memaksimalisasi-manfaat-fitness-di-gym.jpeg',
        merchant_list_banner:
          'http://localhost:81/wp-content/uploads/2022/01/pexels-nout-gons-378570-scaled.jpg',
        merchant_gravatar: 'http://localhost:81/wp-content/uploads/2022/01/745.jpeg',
        merchant_banner:
          'http://localhost:81/wp-content/uploads/2022/01/beautiful-girls-images-39.jpeg',
      },
    };
  }
  console.log('authUser', authUser);
  return (
    <UserContext.Provider value={authUser ? authUser : null}>
      <QueryClientProvider client={queryClient}>
        <Route path="/merchant" component={MerchantPage} />
        <Route path="/profile" component={ProfilePage} />
        <Route path="/transactions" component={TransactionPage} />
      </QueryClientProvider>
    </UserContext.Provider>
  );
};

export default App;
